import styled, { keyframes } from 'styled-components';
import { Colors } from '@/common/colors/colors';
import { getTint } from './helpers/getSearchItems';

const fadeIn = keyframes`
	from { opacity: 0; }
	to { opacity: 1; }
`;

const popIn = keyframes`
	from { opacity: 0; transform: translateY(-12px) scale(0.97); }
	to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 2000;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding-top: 10vh;
	background: rgba(0, 0, 0, 0.35);
	animation: ${fadeIn} 0.15s ease;
`;

export const Card = styled.div`
	width: 920px;
	max-width: 94vw;
	background: white;
	border-radius: 16px;
	box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
	overflow: hidden;
	display: flex;
	flex-direction: column;
	animation: ${popIn} 0.2s ease;
`;

export const Header = styled.div`
	padding: 16px 20px 12px;
	border-bottom: 1px solid ${Colors.gray};
`;

export const SearchRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const Input = styled.input`
	flex: 1;
	border: none;
	outline: none;
	font-size: 18px;
	color: ${Colors.darkBlue};
	background: transparent;

	&::placeholder {
		color: ${Colors.darkGray2};
	}
`;

export const Kbd = styled.kbd`
	background: ${Colors.lightGray};
	color: ${Colors.newGray};
	border: 1px solid ${Colors.gray};
	border-radius: 6px;
	padding: 2px 7px;
	font-size: 12px;
	font-family: inherit;
`;

export const Chips = styled.div`
	display: flex;
	gap: 8px;
	margin-top: 12px;
	flex-wrap: wrap;
`;

export const Chip = styled.button`
	display: flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
	border: 1px solid ${({ color }) => (color ? color : Colors.gray)};
	border-radius: 999px;
	padding: 4px 12px;
	font-size: 13px;
	font-weight: bold;
	cursor: pointer;
	color: ${({ active, color }) => (active ? 'white' : color || Colors.newGray)};
	background: ${({ active, color }) => (active ? color || Colors.newGray : 'white')};
`;

export const ChipCount = styled.span`
	font-size: 11px;
	opacity: 0.8;
`;

export const Results = styled.div`
	max-height: 52vh;
	overflow-y: auto;
	padding: 4px 10px 10px;
`;

export const GroupTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 10px 6px;
	font-size: 11px;
	font-weight: bold;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: ${Colors.darkGray2};

	&::before {
		content: '';
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background: ${({ color }) => color};
	}
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 10px;
	border-radius: 10px;
	cursor: pointer;
	background: ${({ active }) => (active ? Colors.lightGray2 : 'transparent')};
`;

export const IconBubble = styled.div`
	width: 34px;
	height: 34px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: ${({ color }) => getTint(color)};
`;

export const Text = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
`;

export const Name = styled.span`
	font-size: 14px;
	font-weight: bold;
	color: ${Colors.darkBlue};
`;

export const Description = styled.span`
	font-size: 12px;
	color: ${Colors.newGray};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Url = styled.code`
	flex-shrink: 0;
	max-width: 220px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 12px;
	color: ${Colors.darkGray2};
`;

export const Mark = styled.mark`
	background: ${Colors.yellow};
	color: inherit;
	border-radius: 3px;
	padding: 0 1px;
`;

export const Empty = styled.div`
	padding: 30px;
	text-align: center;
	color: ${Colors.darkGray2};
`;

export const Footer = styled.div`
	display: flex;
	gap: 18px;
	padding: 8px 20px;
	border-top: 1px solid ${Colors.gray};
	font-size: 12px;
	color: ${Colors.newGray};
`;
